module.exports = __webpack_public_path__ + "static/media/Close2.25cbdd59.svg";